import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserPhotoService {
    private photoUpdatedSubject = new Subject<void>();
    public photoUpdated$ = this.photoUpdatedSubject.asObservable();

    notifyPhotoUpdated(): void {
        this.photoUpdatedSubject.next();
    }
}
